export default "__VITE_ASSET__Bk3Vzelh__"